import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import LoadingComponent from "src/components/loading";
import { ELanguage, IRoute } from "src/interfaces";
import Page404 from "src/pages/system/404";
import UnauthorizedPage from "src/pages/system/Unauthorized";
import { RootState } from "src/store";
import { updateLanguage } from "src/utils/changLanguage";
import RequireAuth from "./RequireAuth";
import {
  listNoAuthRouters,
  listPrivateRouters,
  sallerProfileRouters,
  listResalesRouters,
} from "./routers";
import TestPage from "src/pages/test";

const HomeComponent = React.lazy(() => import("../pages/home"));
const ResaleTopPage = React.lazy(() => import("../pages/resale-top-page"));

function RenderRouters() {
  const { loading } = useSelector((state: RootState) => state.metadata);
  useEffect(() => {
    const currentLanguage = localStorage.getItem("lang");
    if (!currentLanguage) {
      updateLanguage(ELanguage.JA);
      return;
    }
    updateLanguage(currentLanguage as any);
  }, []);

  const logicRenderRoute = (
    { children = [], element, permissions, layout, ...rest }: IRoute,
    index: number,
    isAuth = false
  ) => {
    const renderElement = isAuth ? (
      <RequireAuth permissions={permissions}>{element}</RequireAuth>
    ) : (
      element ?? <React.Fragment />
    );

    if (children && children.length > 0) {
      return (
        <Route {...rest} element={renderElement} key={index}>
          {children.map((route, indexx: number) => {
            return logicRenderRoute(route, indexx, isAuth);
          })}
        </Route>
      );
    }

    return <Route {...rest} element={renderElement} key={index} />;
  };

  if (loading) {
    return <LoadingComponent loading={loading} />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <React.Suspense fallback={<div>Loading...</div>}>
            <HomeComponent />
          </React.Suspense>
        }
      />
      <Route
        path="/test"
        element={
          <React.Suspense fallback={<div>Loading...</div>}>
            <TestPage />
          </React.Suspense>
        }
      />
      <Route
        path="/resale/top"
        element={
          <React.Suspense fallback={<div>Loading...</div>}>
            <ResaleTopPage />
          </React.Suspense>
        }
      />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      {listNoAuthRouters.map((route: any, index) => {
        return logicRenderRoute(route, index);
      })}
      {listResalesRouters.map((route: any, index) => {
        return logicRenderRoute(route, index);
      })}
      {listPrivateRouters.map((route: any, index) => {
        return logicRenderRoute(route, index, true);
      })}
      {sallerProfileRouters.map((route: any, index) => {
        return logicRenderRoute(route, index);
      })}
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}

export default RenderRouters;
